import max from 'lodash/max';
import min from 'lodash/min';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  screenIndex: 0,
  sessionTypeId: null,
  date: null,
  time: null,
  scheduleManually: false,
  error: null,
  providerAvailabilityId: null,
  locationType: null,
  locationId: null,
  timeCreated: null,
  serviceType: null,
  providerId: null,
};

const MAX_SCREENS = 2;

const slice = createSlice({
  name: 'newAppointmentForm',
  initialState: initialState,
  reducers: {
    next: (state, action) => ({
      ...state,
      // There are 2 screens maximum
      screenIndex: min([state.screenIndex + 1, MAX_SCREENS - 1]),
    }),
    previous: (state, action) => ({
      ...state,
      screenIndex: max([state.screenIndex - 1, 0])
    }),
    setScheduleManually: (state, action) => ({
      ...state,
      screenIndex: 0,
      date: action.payload ? null : state.date,
      time: action.payload ? null : state.time,
      error: null,
      scheduleManually: action.payload,
    }),
    setScreenIndex: (state, action) => ({
      ...state,
      screenIndex: action.payload,
    }),
    setSessionTypeId: (state, action) => ({
      ...state,
      sessionTypeId: action.payload,
    }),
    setProviderId: (state, action) => ({
      ...state,
      providerId: action.payload,
    }),
    setServiceType: (state, action) => ({
      ...state,
      serviceType: action.payload,
    }),
    setProviderAvailabilityId: (state, action) => ({
      ...state,
      providerAvailabilityId: action.payload,
    }),
    setLocationType: (state, action) => ({
      ...state,
      locationType: action.payload,
    }),
    setLocationId: (state, action) => ({
      ...state,
      locationId: action.payload,
    }),
    setDate: (state, action) => ({
      ...state,
      date: action.payload,
    }),
    setTime: (state, action) => ({
      ...state,
      time: action.payload,
    }),
    setTimeCreated: (state, action) => ({
      ...state,
      timeCreated: action.payload,
    }),
    setError: (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    },
    reset: (state, action) => initialState,
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = slice;
// Extract and export each action creator by name
export const {
  next,
  previous,
  setScreenIndex,
  setScheduleManually,
  setSessionTypeId,
  setProviderAvailabilityId,
  setProviderId,
  setDate,
  setTime,
  setLocationType,
  setLocationId,
  setServiceType,
  setTimeCreated,
  setError,
  reset,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
